import React, { useEffect, useState } from "react";
import { Spinner } from "@public/ui-toolkit/src";
import MyFundsTab from "./MyFundTab";
import DocumentsTab from "./DocumentsTab";
import { useQuery } from "../../utils/CustomHook";
import {
  getProfileDetail,
  getAllocatorStrategy,
  getCompanyPostFeedAction,
  getCompanyUsersAction,
  getFundSpotlightAction,
  updateTenantDetail,
  updateTenantCompanyLogo,
  getAllocatorInfoAction,
  updateAllocatorInfoAction,
  createAllocatorInfoAction,
  updateFSIAction,
  updateNDEAction,
  updateIDPAction,
  getallInvestorAction,
  updateInvestorCategoryAction,
  getStrategy
} from "./actions";
import { useDispatch, useSelector } from "react-redux";
import { investFund } from "../MyFunds/actions";
import { Row, Col, Empty, Collapse, Tabs } from "antd";
import { FCNProfileHeader, MyMeetings, NewsFeedComponent, ProfileBulletPoints, TableAUM } from "@hedgefund/shared";
import { RightOutlined } from "@ant-design/icons";
import { createFcnQuery } from "../ContactFCNAdmin/actions";
import { alertService } from "@hedgefund/shared/src/Alert";
import { getMeetingList } from "./MyMeetingsTab/actions";
import { getNumberWithUnit } from "@hedgefund/shared";


const Profile = () => {
  const query = useQuery();
  const tab = query.get("tab");
  const dispatch = useDispatch();
  const [pageSize, setPageSize] = useState(1);
  const [activeTab, setActiveTab] = useState("nav-about-tab");
  const [openFSI, setOpenFSI] = useState(false);
  const [openNDE, setOpenNDE] = useState(false);
  const [openIDP, setOpenIDP] = useState(false);
  const [openIC, setOpenIC] = useState(false)
  const [openLSI, setOpenLSI] = useState(false)


  const [allocatorObj, setAllocatorObj] = useState({})

  const [activeKey, setActiveKey] = useState(new Set(['1']));
  const fundState = useSelector((state) => state.investedFunds);
  const fundProfileDetails = useSelector((state) => state.profile);
  const { profileDetails, page, perPage, spotlightFunds, getAllInvestors, loading, fundSpotloading, postFeedLoading,
    allocatorStratgy, getCompanyPostFeed, stratgyList, getCompanyUsers, companyLogoUrl, allocatorInfo, allocatorInfoLoading } = fundProfileDetails;

  const { fundLoading, investedFunds } = fundState;
  const { meetings } = useSelector((state) => state.meetings);


  useEffect(() => {
    if (tab) {
      setActiveTab(tab);
      onClickTab(tab)
    }
    dispatch(getProfileDetail());
    dispatch(getCompanyUsersAction());
    dispatch(getStrategy());
    dispatch(getAllocatorStrategy());
    dispatch(getAllocatorInfoAction());
    dispatch(getallInvestorAction());

  }, [tab]);

  const onClickTab = (tabId) => {
    switch (tabId) {
      case "nav-about-tab":
        dispatch(getProfileDetail());
        dispatch(getCompanyUsersAction());
        dispatch(getAllocatorStrategy());
        setActiveTab(tabId);
        break;
      case "nav-my-funds-tab":
        dispatch(investFund({ page: pageSize, limit: 20 }));
        setActiveTab(tabId);
        break;
      case "nav-my-spotlight-tab":
        dispatch(getFundSpotlightAction({ page: pageSize, limit: 20 }));
        setActiveTab(tabId);
        break;
      case "nav-my-meetings-tab":
        dispatch(getMeetingList());
        setActiveTab(tabId);
        break;
      case "nav-news-feed-tab":
        dispatch(getCompanyPostFeedAction({ page: page, perPage: perPage }));
        setActiveTab(tabId);
        break;
      default:
        break;
    }
  }

  const onExpand = (panelKey) => {
    const tempSet = new Set(activeKey);
    if (activeKey.has(panelKey)) {
      tempSet.delete(panelKey);
    } else {
      tempSet.add(panelKey);
    }
    setActiveKey(tempSet);
  };

  const onSuccessAlert = () => {
    alertService.success("Successfully Created!", { autoClose: true });
  };

  const onSubmitNewPostHandler = (value) => {
    if (value) {
      dispatch(createFcnQuery(value, onSuccessAlert));
    }
  };
  const updateTenantInfo = (values, onSuccessData) => {
    dispatch(updateTenantDetail(values, onSuccessData));
  }
  const updateTenantLogoImage = (values, onSuccessData, onCloseModal) => {
    dispatch(updateTenantCompanyLogo(values, onSuccessData, onCloseModal));
  }
  const createAllocatorInfo = (val, onSuccess) => {
    dispatch(createAllocatorInfoAction(val, onSuccess));
  }
  const updateAllocatorInfo = (val, onSuccess) => {
    dispatch(updateAllocatorInfoAction(val, onSuccess));
  }
  const onSubmitValue = (val , onSuccess) => {
    const { name , value } = val;
    const obj = { id : allocatorInfo?.id }
    switch (name) {
      case "FSI":
        obj.fsi = value;
        dispatch(updateFSIAction(obj, onSuccess))
        break;
      case "NDE":
        obj.nde = value;
        dispatch(updateNDEAction(obj, onSuccess))
        break;
      case "IDP":
        obj.idp = value;
        dispatch(updateIDPAction(obj, onSuccess))
        break;
      default:
        break;
    }
  }
  const updateInvestorType = (obj, onSuccess) => {
    dispatch(updateInvestorCategoryAction(obj, onSuccess))
  }
  return (
    <main>
      <div className="main-inner">
        {!loading ? (
          <Row style={{ margin: "auto" }}>
            <Col span={7} style={{ minHeight: "800px", backgroundColor: "#fff", borderRadius: "10px", marginLeft: "50px", padding: "10px", border: "1px solid #edeef0" }}>
              <FCNProfileHeader
                companyLogoUrl={companyLogoUrl}
                portal={'allocator'}
                getAllStrategy={getallInvestorAction}
                myProfileState={profileDetails}
                stratagies={getAllInvestors}
                onSubmitNewPostHandler={onSubmitNewPostHandler}
                updateInfo={updateTenantInfo}
                updateTenantLogoImage={updateTenantLogoImage}
              />
            </Col>
            <Col span={16} style={{ backgroundColor: "#fff", borderRadius: "10px", marginLeft: "10px", border: "1px solid #edeef0" }}>
              <Tabs activeKey={activeTab} className="custom-tabs" size="large" onTabClick={(e) => onClickTab(e)} type="card" items={[
                {
                  key: "nav-about-tab",
                  label: `My About`,
                  children: <>
                    <div className="stylish-title text-blue Fund-FontSize">My About</div>
                    <div style={{ padding: "10px" }}>
                      <Collapse
                        activeKey={Array.from(activeKey)}
                        expandIcon={({ isActive, panelKey }) => (
                          <RightOutlined
                            onClick={() => onExpand(panelKey)}
                            rotate={isActive ? 90 : 0}
                          />
                        )}
                      >
                        <Collapse.Panel key="1" header="My About">
                          {allocatorInfoLoading ? (
                            <Row className="text-center">
                            <Col span={24}>
                              <Spinner />
                            </Col>
                            </Row>
                          ) : (
                          <Row>
                            <Col span={24} className="p-2 ">
                              {/* <div className="rounded-large bg-white border p-2">
                                <h5 data-bs-toggle="tooltip" data-bs-placement="top">
                                  AUM - Assets Under Management 
                                </h5>
                                <div className="table-responsive hf-table-2 "> */}
                                  <TableAUM 
                                  title={"AUM - Assets Under Management"} 
                                  aum={profileDetails?.aum}
                                  allocatorInfo={allocatorInfo}  
                                  createAllocatorInfo ={createAllocatorInfo} 
                                  loading={allocatorInfoLoading}
                                  updateInfo = {updateAllocatorInfo}/>
                                {/* </div>
                              </div> */}
                            </Col>

                            <Col span={11} className="p-2 ml-1">

                              <ProfileBulletPoints
                                title="Investor Category"
                                editButton={true}
                                investorData={getAllInvestors}
                                openInput = {openIC}
                                setopenInput = {setOpenIC}
                                value = {allocatorObj}
                                setValue = {() => setAllocatorObj({ name : profileDetails?.investorTypeName , value : profileDetails?.investorTypeId })}
                                onSubmit={updateInvestorType}
                                description={
                                  profileDetails?.investorTypeName
                                    ? profileDetails?.investorTypeName
                                    : "No activity found!"
                                }

                              />
                            </Col>
                            <Col span={12} className="p-2 ml-1">
                              <ProfileBulletPoints
                                title="Investor Decision Process"
                                editButton={true}
                                openInput = {openIDP}
                                setopenInput = {setOpenIDP}
                                value = {allocatorObj}
                                setValue = {() => setAllocatorObj({ name : "IDP", value : allocatorInfo?.idp ? allocatorInfo?.idp : "" })}
                                onSubmit = {onSubmitValue}
                                description={
                                  allocatorInfo?.idp
                                    ? allocatorInfo?.idp
                                    : "No activity found!"
                                }
                              />
                            </Col>
                            <Col span={11} className="p-2 ml-1">
                              <ProfileBulletPoints
                                title="Net Dollar Exposure"
                                editButton={true}
                                openInput = {openNDE}
                                setopenInput = {setOpenNDE}
                                value = {allocatorObj}
                                setValue = {() => setAllocatorObj({ name : "NDE", value : allocatorInfo?.nde ? allocatorInfo?.nde : null })}
                                onSubmit = {onSubmitValue}
                                description={
                                  allocatorInfo?.nde === 0
                                    ? "No activity found!"
                                    : allocatorInfo?.nde
                                      ? getNumberWithUnit(allocatorInfo?.nde)
                                      : "No activity found!"
                                }
                              />
                            </Col>
                            <Col span={12} className="p-2 ml-1">
                              <ProfileBulletPoints
                                title="Firm Size Interest"
                                editButton={true}
                                openInput = {openFSI}
                                setopenInput = {setOpenFSI}
                                value = {allocatorObj}
                                setValue = {() => setAllocatorObj({ name : "FSI", value : allocatorInfo?.fsi ? allocatorInfo?.fsi : null })}
                                onSubmit = {onSubmitValue}
                                description={
                                  allocatorInfo?.fsi === 0
                                    ? "No activity found!"
                                    : allocatorInfo?.fsi
                                      ?  getNumberWithUnit(allocatorInfo?.fsi)
                                      : "No activity found!"
                                }
                              />
                            </Col>
                            <Col span={11} className="p-2 ml-1">
                              <ProfileBulletPoints
                                title="Liquid Strategy Interests"
                                editButton={true}
                                openInput = {openLSI}
                                setopenInput = {setOpenLSI}
                                value = {allocatorObj}
                                setValue = {() => setAllocatorObj({ name : "" , value : "" })}
                                listData={stratgyList}
                                stratagiesList={allocatorStratgy?.map((s) => s.strategies)}
                              />
                            </Col>
                          </Row>
                          )}
                        </Collapse.Panel>
                        <Collapse.Panel key="2" header="Allocator Managers">
                          <Row className="p-3 bg-white">
                            <Col span={24} className="mt-2 mb-3 ml-2">
                              <h5>Allocator Managers</h5>
                            </Col>
                            {getCompanyUsers.length > 0 ? (
                              getCompanyUsers?.map((item) => {
                                return (
                                  <Col span={7} className="ml-4 mb-3 ">
                                    <div className="hf-card2">
                                      <div
                                        className="hf-card2-banner search-fund-card "
                                        style={{ cursor: "pointer" }}
                                      >
                                        <div>
                                          <img className="user-Fund-Card" src={item?.profileUrl ? item?.profileUrl : "/assets/images/bg1.png"} alt="Profile Image" />
                                        </div>
                                      </div>
                                      <div className="hf-card-body p-3" style={{ textAlign: "center" }}>
                                        <ul className="extra-info mt-5">
                                          <li className="mb-2">
                                            <span className="text-dark" style={{ fontSize: "22px", fontWeight: "600", cursor: "pointer" }}>
                                              {item?.fullName}
                                            </span>
                                          </li>
                                          <li className="mb-1">
                                            {item?.title}
                                          </li>
                                          <li className="mb-3">
                                            {item?.emailAddress}
                                          </li>
                                          <li className="mb-3">
                                            <span class="badge badge-secondary p-1 ">Phone :  {item?.phoneNumber}</span>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </Col>
                                )
                              })
                            ) : (
                              <div>
                                <Empty />
                              </div>
                            )}
                          </Row>
                        </Collapse.Panel>
                      </Collapse>
                    </div>
                  </>
                },
                {
                  key: "nav-my-funds-tab",
                  label: `My Funds`,
                  children: <>
                    <div className="stylish-title text-blue Fund-FontSize">My Funds</div>
                    <div className=" ml-4">
                      <div className="row gy-4">
                        <MyFundsTab
                          loading={fundLoading}
                          investedFunds={investedFunds}
                          pageSize={pageSize}
                        />
                      </div>
                    </div>
                  </>
                },
                {
                  key: "nav-my-spotlight-tab",
                  label: `My Fund Spotlight`,
                  children: <>
                    <div className="stylish-title text-blue Fund-FontSize">My Fund Spotlight</div>
                    <div className=" ml-4">
                      <div className="row gy-4">
                        <MyFundsTab
                          loading={fundSpotloading}
                          investedFunds={spotlightFunds?.items}
                          pageSize={pageSize}
                        />
                      </div>
                    </div>
                  </>
                },
                {
                  key: "nav-my-meetings-tab",
                  label: `My Meetings`,
                  children: <>
                    <div className="stylish-title text-blue Fund-FontSize">Meetings</div>
                    <div className="table-responsive hf-table mt-3">
                      <MyMeetings meetings={meetings} portal={"allocator"} />
                    </div>
                  </>
                },
                {
                  key: "nav-news-feed-tab",
                  label: `My News Feed`,
                  children: <>
                    <div>
                      <div className="stylish-title text-blue mt-2 Fund-FontSize">My Posts</div>
                      <NewsFeedComponent
                        loading={postFeedLoading}
                        showButton={false}
                        getPosts={getCompanyPostFeed}
                        type={false}
                        editDeleteIcon={false}
                      />
                    </div>
                    <DocumentsTab />
                  </>
                },
              ]}
              />

            </Col>
          </Row>) : (
          <Row className="text-center">
            <Col span={24}>
              <Spinner />
            </Col>
          </Row>
        )}
      </div>
    </main>
  );
};

export default Profile;
